import { render, staticRenderFns } from "./DataTableNew.vue?vue&type=template&id=c3de80e6&scoped=true"
import script from "./DataTableNew.vue?vue&type=script&lang=js"
export * from "./DataTableNew.vue?vue&type=script&lang=js"
import style0 from "./DataTableNew.vue?vue&type=style&index=0&id=c3de80e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3de80e6",
  null
  
)

export default component.exports